import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./style.css";
import { startOfficeRecorder } from "./recorder";
if (location.pathname === "/recorder") startOfficeRecorder();
else createRoot(document.getElementById("root")!).render(<App />);
